import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-event-sessions.ts';
import { GET_EVENT_FILTERED_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-filtered-event-sessions.ts';
import type { DeleteSessionContributorDto } from '@/types/dtos/sessions/request/delete-session-contributor.dto.ts';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors';
import { GET_FLOW_QUERY_KEY } from '@/state/queries/flows/use-get-flow';
import { GET_SESSION_QUERY_KEY } from '@/state/queries/sessions/use-get-session';

export const useDeleteSessionContributor = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeleteSessionContributorDto) => {
      const token = await getToken();
      return deleteSessionContributor(params, token ?? '');
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_SESSIONS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FILTERED_SESSIONS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_FLOW_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_SESSION_QUERY_KEY],
        }),
      ]);
    },
  });
};

const deleteSessionContributor = async (data: DeleteSessionContributorDto, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/sessions/${data.sessionId}/contributors/${data.contributorId}`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};
